import { useState } from "react";
import { FaPlus, FaStore, FaEye, FaBan } from "react-icons/fa";
import styles from "./Booster.module.css";
import { boosterData } from "../../services/BoosterServices";
import { Link } from "react-router-dom";
import React from "react";
import "./modal.css";
import AddBoosterToStoreModal from "../Modal/AddBoosterToStoreModal/AddBoosterToStoreModal";
import NewICon from "../CssIcon/NewIcon";
import { useTranslation } from "react-i18next";
import { reportStatusEnum } from "../../enums/reportStatusEnum";

interface boosterProps {
  booster: boosterData;
  isInStore: boolean;
  disableHover?: boolean;
  disableClick?: boolean;
}

export type RarityDistribution = {
  common: number;
  silver: number;
  gold: number;
};

const Booster: React.FC<boosterProps> = ({
  booster,
  isInStore = true,
  disableHover = false,
  disableClick = false,
}) => {
  const [isAddBoosterToStoreModalOpen, setIsAddBoosterToStoreModalOpen] =
    useState(false);
  const oneWeekAgo = new Date();
  oneWeekAgo.setDate(oneWeekAgo.getDate() - 2);
  const { t } = useTranslation();

  return (
    <>
      <div className={styles.boosterContent}>
        <div className={styles.storeIcon}>
          {!isInStore && booster.is_in_store && <FaStore size={100} />}
          {booster.status === reportStatusEnum.rejected && <FaBan size={100} />}
        </div>
        {new Date(booster.updated_at) > oneWeekAgo && (
          <div className={styles.newIcon}>
            <NewICon />
          </div>
        )}
        <div>
          {disableClick ? (
            <img
              src={booster.image_id}
              alt="Booster"
              className={`${styles.boosterImage} ${
                !isInStore && booster.is_in_store ? styles.disable : ""
              }
              ${
                booster.status === reportStatusEnum.rejected
                  ? styles.disable
                  : ""
              }
              `}
            />
          ) : (
            <Link to={`/boosters/${booster.id}`} className={styles.unset}>
              <img
                src={booster.image_id}
                alt="Booster"
                className={`${styles.boosterImage} ${
                  !isInStore && booster.is_in_store ? styles.disable : ""
                }       
                ${
                  booster.status === reportStatusEnum.rejected
                    ? styles.disable
                    : ""
                }`}
              />
            </Link>
          )}
        </div>

        {!disableHover && (
          <>
            <div className={styles.boosterTextOverlay}>
              {!isInStore && booster.status !== reportStatusEnum.rejected && (
                <>
                  {!booster.is_in_store ? (
                    <>
                      {/* <Link
                        to={`/creator/boosters/${booster.id}`}
                        className={styles.unset}
                      >
                        <button className={styles.button}>
                          Edit <FaEdit />
                        </button>
                      </Link> */}
                      <Link
                        to={`/creator/boosters/${booster.id}/cards`}
                        className={styles.unset}
                      >
                        <button className={styles.button}>
                          Add cards <FaPlus />
                        </button>
                      </Link>
                      <button
                        onClick={() => setIsAddBoosterToStoreModalOpen(true)}
                        className={styles.button}
                      >
                        Add to store <FaStore />
                      </button>
                    </>
                  ) : (
                    <button
                      onClick={() => setIsAddBoosterToStoreModalOpen(true)}
                      className={styles.button}
                    >
                      Remove from store
                    </button>
                  )}
                  <Link to={`/boosters/${booster.id}`} className={styles.unset}>
                    <button className={styles.button}>
                      Preview <FaEye />
                    </button>
                  </Link>
                </>
              )}

              {/* TODO: SHOW rejected reason */}

              {/* <p className={styles.nbSolds}>
                  {booster.quantity_sold} {t("sold")}
                </p> */}
              {booster.status === reportStatusEnum.rejected && (
                <p className={styles.bannedText}>{t("banned")}</p>
              )}
            </div>
          </>
        )}
      </div>

      <AddBoosterToStoreModal
        isOpen={isAddBoosterToStoreModalOpen}
        onClose={() => setIsAddBoosterToStoreModalOpen(false)}
        booster={booster}
      />
    </>
  );
};

export default Booster;
